import storage from '/home/pedrazzi/projetos/eds/ci4-shield-vuejs/src/composables/storage.js';
const axios = require('axios'),
  api = axios.create({
    baseURL: '/api',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content
    }
  })
api.interceptors.response.use(
  async (response) => {
    return await response.data
  },
  async (error) => {
    return await error.response.data.messages
  }
)
api.interceptors.request.use((config) => {
  const { method } = config,
    token = storage.get('auth.token')
  if (token) config.headers.Authorization = 'Bearer ' + token
  if (method === 'post') {
    const body = new FormData(),
      args = config.data
    Object.keys(args).filter((r) => {
      body.append(r, args[r])
    })
    config.data = body
  }
  return config
})

window.axios = api
export default api
